export { default, PostFooterProps } from './post-footer-common';
